@if (iframeSource) {
  <iframe
    #appIframe
    class="data-iframe"
    [src]="iframeSource"
    title="Application Frame"
    (load)="handleIframeLoad($event)"
    (error)="handleIframeLoad($event)"
  ></iframe>
}
